var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{attrs:{"width":"100%","height":"100%","src":"https://doc.clickup.com/3655722/p/h/3fj1a-117956/65e66a09b61306e","title":"LXP 101"}})
}
var staticRenderFns = []

export { render, staticRenderFns }